<template>
  <NavView></NavView>
    <SideBar></SideBar>
<div class="container-fluid mb-5" >
    <!-- <h4 class="manage-boder">Manage Customer</h4>  -->

    <h6 class="manage-boder pt-2 font1 font-bold1">
       <router-link class="decoration" to="/sinvoice/index"> Manage Spare Parts Invoice </router-link>
     
       <span class="pfimg1"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
       Create Rental Invoice
         </h6>
    
   
    

<div class="card bg-light">
<div class="card-body">

  <div class="container-fluid mt-2 ">

    <p class="clr2"><b>Add other Details</b> </p>



<Table id=""  class="font1 table table-bordered  table-sm ">
  <tbody>
    <tr>
   <th>#</th>
   <th>Product Code</th>
   <th>Brand</th>
   <th>Model</th>                  
   <th>Registration No.</th>                  
   <th>Rental Period</th>                  
   <th>Rate Type</th>                  
   <th>Rate Amount</th>                  
   <th>Qty</th>                  
   <th>Invoice From</th>                  
   <th>Invoice To</th>                  
   <th>Bill Amount</th>                  
    </tr>
    <tr v-for="detail in details" :key="detail">
        
        <td></td>
        <td>test</td>
        <td>{{detail.machine}}</td>
        <td>{{detail.model}}</td>
        <td>{{detail.serial_no}}</td>
        <td>{{detail.propose_start_date}} to <br> {{detail.propose_return_date}}</td>
        <td>{{detail.ratetype}}</td>
        <td>{{detail.charge_amount}}</td>
        <td>{{detail.SD_qty}}</td>
        <td><input v-model="invoice_details.invoice_frm" @change="billCalculate(detail.charge_amount)"  class="form-control font1" type="date"></td>
        <td><input v-model="invoice_details.invoice_to" @change="billCalculate(detail.charge_amount)" class="form-control font1" type="date"></td>
        <td><input v-model="invoice_details.line_amount" class="form-control font1"  disabled ></td>
    </tr>

    


  </tbody>
 
    
  
</Table>




<div class="d-grid gap-2 d-md-flex justify-content-md-end mb-5">
<Table class="font1 table table-borderless w-35  table-sm">
    <tbody>
        <tr>
            <th>Sub Total</th>
            <th class="align-right">{{invoice_details.line_amount}}</th>
        </tr>
        <tr>
            <th>Additional Charges</th>
            <th class="align-right">{{invoice_charges.charge_amount}}</th>
        </tr>
        <tr>
            <th>GST</th>
            <th class="align-right">{{invoice.vat_amout}}</th>
        </tr>
        <tr>
            <th>Total</th>
            <th class="align-right">{{invoice.total_invoice_amt}}</th>
        </tr>
        <tr>
            <th>Less Adv.</th>
            <th class="align-right">0.00</th>
        </tr>
        <tr>
            <th>Total Payable</th>
            <th class="align-right">{{invoice.total_invoice_amt}}</th>
        </tr>
    </tbody>
</Table>
</div><br>
<div>
    <div class="row font1">

        <CCol md="3 font1">
            <CFormLabel for="inputName4 ">Customer Name</CFormLabel>
             <!-- <CFormInput   v-model="customer.name"  type="text" id="inputName4"/> -->
            

             <Field name="name" v-model="stock_issue2.name_customer" class="form-control font1"  disabled />
            
            
            
        </CCol>
        <CCol md="3 font1">
            <CFormLabel for="inputName4 ">Invoice Type</CFormLabel>
             <!-- <CFormInput   v-model="customer.name"  type="text" id="inputName4"/> -->
            

             <Field name="name" v-model="invoice.invoice_type"  class="form-control font1" disabled/>
            
            
            
        </CCol>
        <CCol md="3 font1">
            <CFormLabel for="inputName4 ">Sales Person</CFormLabel>
             <!-- <CFormInput   v-model="customer.name"  type="text" id="inputName4"/> -->
            

            <select class="form-control font1">
                <option>select....</option>
                <option>testing</option>
            </select>
            
            
            
        </CCol>
        <CCol md="3">
            <CFormLabel for="inputName4">Customer Delivery Address</CFormLabel>
             <!-- <CFormInput   v-model="customer.name"  type="text" id="inputName4"/> -->
           
               <table class="table table-borderless  form-control font1 ">
                <tbody>
                  <tr>
                    <td>{{stock_issue2.C_address_line1 }},{{ stock_issue2.C_address_line2 }},{{ stock_issue2.C_address_line3}}</td>
                  </tr>
                </tbody>
              </table> 
              
            
            
            
        </CCol>
        </div>
        <div class="row font1">
            <CCol md="3">
                <CFormLabel for="inputName4">Remarks</CFormLabel>
                 <!-- <CFormInput   v-model="customer.name"  type="text" id="inputName4"/> -->
                
    
                 <textarea  v-model="invoice.inv_remarks" class="form-control font1"  rows="3"></textarea>    
               
                
                
            </CCol>

        </div>
</div><br>
<p class="clr2"><b>Rental Additional Charges</b> </p>
<div>
    <table class="font1 table table-bordered  table-sm  table-striped">
        <thead>
            <tr>
                <th></th>
                <th>Additional Charge</th>
                <th>Description</th>
                <th>Amount</th>
                <th></th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td></td>
                <td><input type="text" class="form-control"></td>
                <td><input type="text" class="form-control"></td>
                <td><input @change="totalCalculate()" v-model="invoice_charges.charge_amount" type="number" class="form-control"></td>
                <td><span @click="add"  type="button"><i class="fa fa-plus mt-3" aria-hidden="true"></i></span></td>
            </tr>
            <tr v-for="key in count" :key="key">
                <td><span @click="remove"  type="button"><i class="fa fa-minus mt-3" aria-hidden="true"></i></span></td>
                <td><input class="form-control"></td>
                <td><input class="form-control"></td>
                <td><input class="form-control"></td>
                <td><span @click="add"  type="button"><i class="fa fa-plus mt-3" aria-hidden="true"></i></span></td>
            </tr>
        </tbody>
    </table>
</div>

<br>


<p class="clr2"><b>Received Advance Payments</b> </p>
<div>
    <table class="font1 table table-bordered  table-sm  table-striped">
        <thead>
            <tr>
                <th></th>
                <th>Receipt No</th>
                <th>Receipt Date</th>
                <th>Paid Amount S($)</th>
                <th>Status</th>
                <th>Payment Status</th>
            </tr>
        </thead>
        <tbody>
            <tr >
                <td></td>
                <td>test</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
        </tbody>
    </table>
</div>


<div class="right1 mt-4">
                       
                    
    <div class="d-grid gap-2 d-md-flex justify-content-md-end mb-5">
    
        
        <button v-on:click="saveData()" class="line1 btn btn-primary " >Create</button>
    </div>
</div>
</div>
</div>
</div>


</div>
<!-- <button v-on:click="loadData1()" type="" class="btn btn-danger" >press</button> -->
<!-- <form @submit.prevent="del()" class="" >
 <input type="text" v-model="user.id"  class="form-control" >
 <button  type="" class="btn btn-success" >delete</button>
 </form> -->

</template>

<script>
    import {  CCol, CFormLabel, } from '@coreui/vue';
    import {  Field  } from 'vee-validate';
 //import {   CButton, } from '@coreui/vue';
 //import httpClient from '@/axios';
 import axios from 'axios';
 import authService from '@/auth.service';
 import NavView from '../NavView.vue'
  import SideBar from '../SideBar.vue'

 
 


export default {
    components:{ 
      NavView,SideBar, CCol,Field,CFormLabel
    },

    created(){
      this.loadData(this.$route.query.id);
    },

    mounted(){
      this.variableLoad()
    },


    data(){


  
    return{
      
      stock_issue:'',
      stock_issue2:'',
      details:'',
      access_token:authService.isLoggedIn(),
     
  
      count: 1,
      invoice:{
        'vat_amout':0,
        'total_invoice_amt':0,
        'id_customer':'',
        'invoice_type':'Rental Invoice',
        'i_sales_person':'1',
        'status':'7',
        'discount_percentage':'0.00',
        'end_user':'test',
        'end_user_address':'test_address',
        'created_by':'7',
        'created_date':'created_date',
        'tot_fixed':'',
        'inv_remarks':'',
      },

      invoice_details:[
        {
        'invoice_frm':'',
        'invoice_to':'',
        'line_amount':0,
        'idproduct':0,
        'price':10, 
        'new_price':10, 
        'discount':0, 
        'discount_amt':0, 
        'days_used':0, 
        'id_gin_dtl':33, 
      }
    ],
      invoice_charges:{
        'charge_amount':0,
      },
     
    
    
  
    };
    },


   methods:{ 
    variableLoad(){
   this.invoice.id_customer = this.stock_issue.id_customer;
   console.log("amila");
   console.log(this.stock_issue.id_customer);

    },
  
    billCalculate(rate){
      this.invoice_details.line_amount = (Date.parse(this.invoice_details.invoice_to) - Date.parse(this.invoice_details.invoice_frm))*rate/86400000;
      console.log( this.invoice_details.line_amount);
     this.invoice.vat_amout = (this.invoice_details.line_amount + this.invoice_charges.charge_amount)*7/100;
     this.invoice.total_invoice_amt = this.invoice_details.line_amount + this.invoice_charges.charge_amount + this.invoice.vat_amout;
    },
    totalCalculate(){
      this.invoice.vat_amout = (this.invoice_details.line_amount + this.invoice_charges.charge_amount)*7/100;
     this.invoice.total_invoice_amt = this.invoice_details.line_amount + this.invoice_charges.charge_amount + this.invoice.vat_amout;
    },

 
  
  
    async  loadData(userid) {
    console.log(userid);
   
     try {
     
      const { data} = await  axios.get('/web/api/istockissue/view?id='+userid,{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.stock_issue = data.item_list;
       this.stock_issue2 = data.item_list2;
      
      
       this.details = data.details;
     } catch (error) {
      console.log(error.response);
     }
    
   
    } ,

    async saveData() {
      // console.log("here we are",this.errorlist); check karaganimata awashya we
      console.log(this.invoice);
      this.invoice.id_customer = this.stock_issue.id_customer;
      this.invoice.tot_fixed = this.invoice_charges.charge_amount;

      try {
        const { data} = await  axios.post('/web/api/sinvoice/create' ,{invoice:this.invoice,details:this.invoice_details},{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
      } catch (error) {
        console.log(error);
      }
   
        
   

    },
        




   
             add: function(){
            this.count++;
           
            },

            remove: function () {
            this.count--;
          
            },
 




}




};

</script>

<style scoped>
.w-35{
    width: 35%;
}
.width8{
  width: 175px;
}
.button1{
  width: 10px !important;
}
.border1{
  border: none;
  background-color: #0d6efd;
}
.font-color1:hover{
  color: black !important;
  cursor: pointer;
}
.manage-boder{
  border-bottom: 1px solid #E9E9E3;
  border-top: 1px solid #E9E9E3;
}


.font1{
      font-size: 13px !important;
   
    }
    .font-bold1{
      font-weight: bold;
    }
    .manage-boder{
    border-bottom: 2px solid #E9E9E3;
    border-top: 2px solid #E9E9E3;
    padding-bottom: 10px !important;
    padding-top: 10px !important;
    
    }
    .font1{
      font-size: 13px !important;
   
    }
    .font-bold1{
      font-weight: bold !important;
    }
    .colr1{
        color:#A5A5A3;
        
    }
    .decoration{
    text-decoration: none;
    color:#A5A5A3  ;
  }
  .width7{
    width: 250px;
  }
  .align-right{
    text-align: right !important;
    padding-top: 11px !important;
    padding-right: 20px !important;
  }
  .mt-my{
    margin-top: 2px;
  }
  .btn1 {
        padding-left: 18px;
        padding-right: 18px;
    }
    
    .clr2 {
        background-color: #AED8F2;
        padding: 2px;
        border-radius: 3px
    }
  
 
</style> 